import * as types from '../types'

// 变量名
const defaultState = {
  menuData: null,
  buttonData: null
}

/**
 * limits权限数据 reducer
 * state: 默认值为defaultState
 * action：调用时需要传的参数
 * */
export default function limits(state = defaultState, action = {}) {
  const { 
    type,     // 调用时传的方法名
    payload     // 调用时传的参数
  } = action
  const res = Object.assign({}, state)
  switch (type) {
    // 添加菜单数据
    case types.ADD_MENU_LIMITS:
      res.menuData = payload.data
      localStorage.setItem('menuData', JSON.stringify(payload.data))
      // return Object.assign({}, state, { menuData:  payload.data})
      break
    // 清空菜单数据
    case types.CLEAR_MENU_LIMITS:
      res.menuData = []
      localStorage.removeItem('menuData')
      break
    // 添加页面按钮数据
    case types.ADD_BUTTON_LIMITS:
      res.buttonData = payload.data
      localStorage.setItem('buttonData', JSON.stringify(payload.data))
      break
    // 清空页面按钮数据
    case types.CLEAR_BUTTON_LIMITS:
      res.buttonData = []
      localStorage.removeItem('buttonData')
      break

    default:

  }
  return res
}